import Merchandising from './Merchandising';

export default Merchandising;
